function logout({ output, services }) {
  services.Http
    .post('/api/user/logout', {})
    .then(output.success)
    .catch(output.error)
}

logout.async = true
export default logout



// WEBPACK FOOTER //
// ./src/modules/user/actions/logout.js